import axios from '@/api/axios-promotions'
import { DateTime } from 'luxon'

const state = {
  promotion: null,
  promotions: [],
  allPromotions: [],
  promotionPackageOptions: [],
  promotionTotalPage: 0,
  promotionIsLoading: false,
  provinceOptions: [],
}

const mutations = {
  setPromotion(state, promotion) {
    state.promotion = promotion
  },
  setPromotions(state, promotions) {
    state.promotions = promotions
  },
  setAllPromotions(state, promotions) {
    state.allPromotions = promotions
  },
  setPromotionPage(state, pages) {
    state.promotionTotalPage = pages
  },
  setPromotionIsLoading(state, status) {
    state.promotionIsLoading = status
  },
  setPromotionPackageOptions(state, options) {
    state.promotionPackageOptions = options
  },
  setProvinceOptions(state, options) {
    state.provinceOptions = options
  },
}

const actions = {
  getPromotions: async (
    { commit, getters },
    { page = 1, limit = 15, query = null, offer_group_id = null, status = null }
  ) => {
    commit('setPromotionIsLoading', true)
    let params = {
      page: page,
      limit: limit,
      query: query,
      offer_group_id: offer_group_id,
      status: status,
    }

    params = Object.fromEntries(
      Object.entries(params).filter(([key, value]) => value !== null)
    )
    await axios
      .get('/promotions', {
        params: params,
      })
      .then((res) => {
        if (res.data !== null) {
          commit('setPromotions', res.data.data)
          commit('setPromotionPage', res.data.meta.pagination.pages)
        } else {
          commit('setPromotions', [])
        }
        commit('setPromotionIsLoading', false)
      })
      .catch((err) => {
        commit('setPromotionIsLoading', false)
      })
  },
  geAllPromotions: async ({ commit, getters }) => {
    commit('setPromotionIsLoading', true)
    let params = {
      page: 1,
      limit: 999,
    }

    params = Object.fromEntries(
      Object.entries(params).filter(([key, value]) => value !== null)
    )

    await axios
      .get('/promotions', {
        params: params,
      })
      .then((res) => {
        if (res.data !== null) {
          commit('setAllPromotions', res.data.data)
          // commit('setPromotionPage', res.data.meta.pagination.pages)
        } else {
          // commit('setPromotions', [])
        }
        // commit('setPromotionIsLoading', false)
      })
      .catch((err) => {
        // commit('setPromotionIsLoading', false)
      })
  },
  getPromotion: async ({ commit }, id) => {
    commit('setPromotionIsLoading', true)
    await axios
      .get(`/promotions/${id}`)
      .then((res) => {
        if (res.data !== null) {
          let form = res.data
          res.data = {
            ...form,
            start_date: getDate(form.start_date),
            end_date: getDate(form.end_date),
            start_time: getTimeHMFromTimestamptz(form.start_date),
            end_time: getTimeHMFromTimestamptz(form.end_date),
          }

          commit('setPromotion', res.data)
        } else {
          commit('setPromotion', null)
        }
        commit('setPromotionIsLoading', false)
      })
      .catch((err) => {
        commit('setPromotionIsLoading', false)
      })
  },
  getPromotionPackageOptions: async ({ commit }, data) => {
    commit('setPromotionIsLoading', true)
    await axios
      .get('/promotions/packages')
      .then((res) => {
        commit('setPromotionIsLoading', false)
        commit('setPromotionPackageOptions', res.data)
      })
      .catch((err) => {
        commit('setPromotionIsLoading', false)
        console.error(err)
      })
  },
  createPromotion: async ({ commit }, form) => {
    await axios
      .post('/promotions', form)
      .then((res) => {})
      .catch((err) => {
        console.log(err)
      })
  },
  editPromotion: async ({ commit }, { id, form }) => {
    await axios
      .put('/promotions/' + id, form)
      .then((res) => {
        console.log(res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  copyPromotion: async ({ commit, dispatch, getters }, { ...form }) => {
    let destructForm = form
    let {
      created_at,
      updated_at,
      id,
      audience_setting,
      revcat_package_id,
      package_name,
      name,
      ...newForm
    } = form
    destructForm = newForm

    let campaign_name = destructForm.campaign_name

    function isInteger(value) {
      return /^\d+$/.test(value)
    }

    if (
      typeof campaign_name[campaign_name.length - 2] != 'undefined' &&
      isInteger(campaign_name[campaign_name.length - 2])
    ) {
      let newName = campaign_name.split('')
      newName[newName.length - 2] = parseInt(newName[newName.length - 2]) + 1
      campaign_name = newName.join('')
    } else {
      campaign_name = campaign_name + '(1)'
    }
    destructForm.name = name

    const copiedForm = { ...destructForm, ...audience_setting }

    await axios
      .post('/promotions', { ...copiedForm })
      .then((res) => {
        dispatch('setAlertMessage', {
          message: 'คัดลอกโปรโมชั่นแล้ว',
          type: 'success',
        })
        commit('clearCurrentAd')
      })
      .catch((res) => {
        let errorMessage = res.response.data.error
        console.error(errorMessage)
        dispatch('setAlertMessage', {
          message: `error: something went wrong`,
          type: 'red darken-3',
        })
      })
  },
  deletePromotion: async ({ commit }, { id }) => {
    await axios
      .delete('/promotions/' + id)
      .then()
      .catch((err) => console.error(err))
  },
  getProvinceOptions: async ({ commit }) => {
    await axios
      .get('/provinces')
      .then((res) => {
        if (res.data != null) {
          commit('setProvinceOptions', res.data)
        }
      })
      .catch((err) => console.error(err))
  },
}

const getters = {
  promotion: (state) => {
    return state.promotion
  },
  allPromotions: (state) => {
    return state.allPromotions
  },
  promotions: (state) => {
    return state.promotions
  },
  promotionTotalPage: (state) => {
    return state.promotionTotalPage
  },
  promotionIsLoading: (state) => {
    return state.promotionIsLoading
  },
  promotionPackageOptions: (state) => {
    return state.promotionPackageOptions
  },
  provinceOptions: (state) => {
    return state.provinceOptions
  },
}

function getDate(date) {
  if (!date) return ''
  const dt = DateTime.fromISO(date)
  const dateOnly = dt.toISODate()
  return dateOnly
}

function getTimeHMFromTimestamptz(timestampString) {
  if (!timestampString) return ''
  return new Date(timestampString).toTimeString().split(' ')[0].substring(0, 5)
}

export default {
  state,
  mutations,
  actions,
  getters,
}
